var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.recaptchaEnabled
    ? _c("p", { staticClass: "recaptcha-notice" }, [
        _vm._v(" Este site é protegido pelo reCAPTCHA. Aplicam-se a "),
        _c(
          "a",
          {
            attrs: {
              href: "https://policies.google.com/privacy",
              target: "_blank",
              rel: "noopener noreferrer",
            },
          },
          [_vm._v("Política de Privacidade")]
        ),
        _vm._v(" e os "),
        _c(
          "a",
          {
            attrs: {
              href: "https://policies.google.com/terms",
              target: "_blank",
              rel: "noopener noreferrer",
            },
          },
          [_vm._v("Termos de Serviço")]
        ),
        _vm._v(" do Google. "),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }